import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { sensors } from '@store/IntegrationsData';

import * as styles from './Sensors.module.scss';

export const Sensors: React.FC = () => {
	return (
		<PaddingContainer className="white-bg">
			<WidthContainer>
				<h2 className="font-size-medium-title font-600">Sensors</h2>
				<p className={classNames(styles.subtitle, 'font-size-sm')}>
					Integrations between API and sensors are crucial for most IoT
					solutions. Types of sensors for integrations:
				</p>
				<div
					className={classNames(
						styles.list,
						'my-5 d-flex flex-wrap align-items-center justify-content-xl-between'
					)}
				>
					{sensors.map((sensor) => (
						<div key={sensor.name} className={styles.item}>
							<div className={styles.itemImg}>
								<img src={sensor.icon} width={70} height={70} />
							</div>
							<p className="mt-4 font-size-14">{sensor.name}</p>
						</div>
					))}
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
